import { environment } from '~/config'

export const SENTRY_SHARED_CONFIGURATION = {
  tracesSampleRate: 1,
  dsn: environment.SENTRY_DSN,
  environment: `${environment.SENTRY_ENVIRONMENT || 'development'}`,
  release: 'latest',
}
